import { useEffect, useState } from "react";
import { Instagram } from "@styled-icons/boxicons-logos/Instagram";
import { LinkedinSquare } from "@styled-icons/boxicons-logos/LinkedinSquare";
import { Github } from "@styled-icons/boxicons-logos/Github";
import { PERSONALINFO } from "../../util/constants/personalInfo";
import { BP } from "../../util/constants/breakpoints";


export default function Footer(){

    const mobileIconWidth = 25;
    const desktopIconWidth = 30;
    const [iconWidth, setIconWidth] = useState(mobileIconWidth);

    const iconClass = `
        hover:text-footer-text-primary
        transition-colors 
        duration-300
    `;

    const onWindowWidthChange = () => {
        setIconWidth(getIconWidth())
    }

    const getIconWidth = () => {
        if(window.innerWidth < BP.sm) return mobileIconWidth 
        else return desktopIconWidth 
    }

    useEffect(() => {
        setIconWidth(getIconWidth)
        window.addEventListener("resize", onWindowWidthChange)
        return () => window.removeEventListener("resize", onWindowWidthChange)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return(
        <footer
            className="
                flex
                justify-between
                items-center
                p-2
                sm:p-7
                bg-body-bg-light
                dark:bg-body-bg-dark
                dark:text-footer-text-dark
                text-footer-text-light
            "
        >
            <span
                className="
                    text-[10px]
                    sm:text-xs
                "
            >
                2025 © Wei Jian Tan
            </span>

            <div
                className="
                    flex
                    justify-between
                "
            >

                <a
                    href={PERSONALINFO.instagramLink}
                    target="_blank"
                    rel="noreferrer"
                >
                    <Instagram className={iconClass} width={`${iconWidth}`} />
                </a>

                <a
                    className="mx-2 sm:mx-3"
                    href={PERSONALINFO.linkedInLink}
                    target="_blank"
                    rel="noreferrer"
                >
                    <LinkedinSquare className={iconClass} width={`${iconWidth}`} />
                </a>

                <a
                    href={PERSONALINFO.githubLink}
                    target="_blank"
                    rel="noreferrer"
                >
                    <Github className={iconClass} width={`${iconWidth}`} />
                </a>

            </div>


        </footer>
    );
}